import { render } from "./OrigenYNacionalidadSection.vue?vue&type=template&id=a78349ec"
import script from "./OrigenYNacionalidadSection.vue?vue&type=script&lang=js"
export * from "./OrigenYNacionalidadSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__